<template>
  <aw-dropdown
    placement="bottom-end"
    :offset="[0, 6]"
    class="relative cursor-pointer inline-flex items-center"
  >
    <template v-slot:btn="{ toggle }">
      <div @click="toggle" class="inline-flex items-center">
        <aw-icon
          icon="bell"
          class="w-5 h-5 text-gray-200 hover:text-gray-400"
          :class="{
            '!text-red-600': unread
          }"
        ></aw-icon>
      </div>
    </template>
    <template v-slot:dropdown="{ opened, dropdown, close }">
      <div
        v-show="opened"
        :ref="dropdown"
        class="Dropdown Dropdown--Notifications Dropdown--Hover absolute rounded bg-white max-w-xs text-sm top-full right-0 shadow-md z-10"
      >
        <div 
          v-if="loading" 
          class="p-0 h-48 flex items-center justify-center"
        >
          <aw-icon
            v-if="loading"
            icon="loading"
            class="animate-spin w-8 h-8"
          />
        </div>
        <div 
          v-else 
          class="p-0"
        >
          <div class="px-3 py-2 no-hover flex">
            <b class="text-lg">{{ $t('Notifications') }}</b>
            <button
              class="pill__Tab pill__Tab-sm ml-auto"
              :class="{ 'pill__Tab-active': view === 'all' }"
              @click="view = 'all'"
            >
              {{ $t('All') }}
            </button>
            <button
              class="pill__Tab pill__Tab-sm ml-1"
              :class="{ 'pill__Tab-active': view === 'unread', 'muted': !unread }"
              @click="view = 'unread'"
            >
              {{ $t('Unread') }}
            </button>
          </div>
          <div
            v-for="item in displayedNotifications"
            :key="item.id"
            class="flex items-center py-1 px-4 border-b border-gray-200"
          >
            <span>
              <span
                class="w-2.5 h-2.5 inline-block shadow-md mr-3 rounded-full"
                :class="{
                  'bg-blue-600': !item.read,
                  'border-blue-600 border-1': item.read
                }"
              />
            </span>
            <a
              v-if="!item.download"
              :href="item.link"
              :class="{ 'font-bold': !item.clicked }"
              @click="markClick(item, close)"
            >
              {{ item.user.label }} {{ item.message }}
            </a>
            <a
              v-if="item.download"
              :href="item.link"
              :class="{ 'font-bold': !item.clicked }"
              @click="markClick(item, close)"
              download
            >
              {{ item.user.label }} {{ item.message }}
            </a>
          </div>
          <a 
            href="/notification.notification" 
            class="flex items-center py-2 px-3 border-b border-gray-200 font-bold text-bc-blue"
          >
            <aw-icon
              icon="bell"
              class="w-5 h-5 mr-1.5"
            />
            {{ $t('All notifications') }}
            <aw-icon
              icon="chevron-right"
              class="w-5 h-5 ml-auto"
            />
          </a>
          <a 
            href="/notification.approval" 
            class="flex items-center py-2 px-3 border-b border-gray-200 font-bold text-bc-blue"
          >
            <aw-icon
              icon="tick"
              class="w-5 h-5 mr-1.5"
            />
            {{ $t('All approvals') }}
            <aw-icon
              icon="chevron-right"
              class="w-5 h-5 ml-auto"
            />
          </a>
          <a 
            href="/notification.comment" 
            class="flex items-center py-2 px-3 border-b border-gray-200 font-bold text-bc-blue"
          >
            <aw-icon
              icon="comment-empty"
              class="w-5 h-5 mr-1.5"
            />
            {{ $t('All comments') }}
            <aw-icon
              icon="chevron-right"
              class="w-5 h-5 ml-auto"
            />
          </a>
          <button
            v-if="unread"
            href="/notification.notification" 
            class="flex items-center w-full py-2 px-3 border-gray-200 font-bold text-bc-blue"
            @click="markRead()"
          >
            <aw-icon
              icon="done-all"
              class="w-5 h-5 mr-1.5"
            />
            {{ $t('Mark all as read') }}
          </button>
        </div>
      </div>
    </template>
  </aw-dropdown>
</template>

<script>
import { NotificationApi } from '../test-api/index.ts'
import handleApiError from '../utils/handleApiError';

const notificationApi = new NotificationApi({}, '/api/v2')

export default {
  data() {
    return {
      unread: null,
      notifications: [],
      loading: false,
      unreadNotifications: [],
      view: 'all'
    }
  },
  methods: {
    async markClick(item, close) {
      close()

      if (item.read && item.click) {
        return
      }

      await handleApiError(() => notificationApi.notificationRead({
        notification_ids: [item.id],
        clicked: true
      }))
    },
    async markRead() {
      const unread = this.notifications.filter((item) => !item.read)
      if (!unread.length) {
        return
      }

      await handleApiError(() => notificationApi.notificationReadAll({
        clicked: false
      }))
      this.checkNew()
      this.unread = null
      this.view = 'all'
    },
    async loadNotifications() {
      this.loading = true
      const listResponse = await handleApiError(() => notificationApi.notificationList())
      const listUnreadResponse = await handleApiError(() => notificationApi.notificationListUnread())
      this.notifications = listResponse.data
      this.unreadNotifications = listUnreadResponse.data
      this.loading = false
    },
    async checkNew() {
      const statsResponse = await handleApiError(() => notificationApi.notificationStats())
      if (statsResponse.data.unread !== this.unread) {
        this.loadNotifications()
        this.unread = statsResponse.data.unread
      }
      setTimeout(this.checkNew, 15000)
    }
  },
  computed: {
    displayedNotifications() {
      if (this.view === 'all') {
        return this.notifications
      } else {
        return this.unreadNotifications
      }
    }
  },
  mounted() {
    this.checkNew()
  }
}
</script>

<style lang="scss" scoped></style>
